import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "row form-row overflow-auto",
  style: {"max-height":"365px"}
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "trigger", { click: _ctx.open }),
    _createVNode(_component_modal, {
      modelValue: _ctx.modal,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modal) = $event))
    }, {
      header: _withCtx(() => _cache[1] || (_cache[1] = [
        _createTextVNode("Select An Image")
      ])),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "gallery-sizer col-sm-6 col-md-6 col-xl-3 position-absolute" }, null, -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageOptions, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "gallery-thumbnail col-sm-6 col-md-6 col-xl-3 mb-2",
              "data-tag": "nature"
            }, [
              _createElementVNode("a", {
                href: "javascript:void(0)",
                onClick: ($event: any) => (_ctx.select(item)),
                class: "img-thumbnail img-thumbnail-zoom-in"
              }, [
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "img-thumbnail-overlay bg-dark opacity-25" }, null, -1)),
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "img-thumbnail-content display-4 text-white" }, [
                  _createElementVNode("i", { class: "fa fa-check" })
                ], -1)),
                _createElementVNode("img", {
                  src: item.location,
                  class: "img-fluid"
                }, null, 8, _hoisted_3)
              ], 8, _hoisted_2)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}